import React from "react";
import PropTypes from "prop-types";
import {Operation} from "@morningtrain/resources";

function LabelForRoute(props) {

    if (props.label) {
        return props.label;
    }

    /// We will assumes that children should be rendered if they are provided
    if(React.Children.count(props.children) > 0) {
        return props.children;
    }

    if(!!props.route) {
        const operation = Operation.fromRoute(props.route);

        if(operation) {
            let label = operation.getEnv('title', null);
            if(label) {
                return label;
            }
        }
    }

    return null;
}

LabelForRoute.defaultProps = {
    label: null,
    route: null,
};

LabelForRoute.propTypes = {
    label: PropTypes.string,
    route: PropTypes.string,
};

export default LabelForRoute;
